import {Directive, Output, HostListener, EventEmitter} from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Output() public clickOutside = new EventEmitter();
  localEvent = null;

  @HostListener('click', ['$event'])
  onClick(event) {
    this.localEvent = event;
  }

  @HostListener('document: click', ['$event'])
  onDocumentClick(event) {
    if (event !== this.localEvent) {
      this.clickOutside.emit(event);
    }
    this.localEvent = null;
  }
}
